export const ABOVE_CONTRACT_TOOLTIP =
  "You're running above your contracted workers. Time spent above the limit draws down your burst budget.";

export const BURST_BUDGET_TOOLTIP =
  "Your contract allows a share of the cycle's minutes to run above your contracted workers without overage — a finite burst allowance. This shows how much you've used and have left for the rest of the cycle.";

export const ZERO_BURST_BUDGET_TOOLTIP =
  "Your contract includes no burst allowance, so any time spent above your contracted workers may incur overage charges.";

export const PEAK_TOOLTIP =
  "The highest concurrent private worker count reached on any day of the cycle so far.";
